import styled from 'styled-components';

export const Heading = styled.div`
  font-weight: 600;
`;

export const FormLabel = styled.p`
  font-size: 16px;
  font-weight: ${props => (props.isEnabled ? '500' : '500')};
  color: ${props => (props.isEnabled ? '#4b286d' : '#666')};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  border: 1px solid ${props => (props.isEnabled ? '#4b286d' : '#e4e4e4')};
  padding: 0.75rem;
  border-left: 7px solid ${props => (props.isEnabled ? '#4b286d' : '#888')};
`;
